import React from "react";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CategoryList from "../../../components/admin/category/CategoryList";

function CategoryListPage() {
  return (
    <AdminLayout>
      <CategoryList />
    </AdminLayout>
  );
}

export default CategoryListPage;
